import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type LawFields, LawFieldsService, type TUser } from '@/types/generated'

export const useLawFieldStore = defineStore('lawFieldStore', () => {
  const lawFields = ref<LawFields | null>(null)

  const fetchLawFields = async () => {
    lawFields.value = await LawFieldsService.lawFieldsRetrieve()
  }

  const getLawFieldOptions = (user: TUser) => {
    const lawFields = user?.org.law_fields || []
    return (lawFields as string[]).map((lawField) => ({
      value: lawField,
      title: lawField
    }))
  }

  const getLawTopicOptions = (lawField: string) => {
    if (!lawFields.value) return []
    if (!lawField) return []
    return (
      lawFields.value?.data[lawField]?.map((topic) => ({
        value: topic,
        title: topic
      })) || []
    ).sort((a, b) => a.value.localeCompare(b.value))
  }

  return {
    lawFields,
    fetchLawFields,
    getLawTopicOptions,
    getLawFieldOptions
  }
})
